export default {
  email: 'Correo',
  name: 'Nombre',
  picture: 'Foto',
  preservedBy: 'Preservado por',
  poweredBy: 'Apoyado por',
  attachments: 'Archivos',
  conjunctions: {
    and: 'y',
  },
  messages: {
    errors: {
      couponExpired: 'Este cupón está expirado o ya ha sido usado.',
    },
    enterprise: {
      areaZoom: 'Compensación',
      maxZoom: 'Elige tu m2',
      minZoom: 'El Mundo',
    },
    map: {
      areaZoom: 'Parque',
      maxZoom: 'Elige tu PIC',
      minZoom: 'El Mundo',
    },
    mobile: {
      coupon: 'Canjear cupón',
      payment: 'Aleatorio',
    },
    mobileRedeem: {
      congratsMessage: 'Eres oficialmente un conservador de PIC en %{project}.%{breakline}Muchas gracias por tu apoyo!',
      congratsTitle: '¡Bienvenido %{name}!',
      header: 'Canjea un Cupón',
      plotsInputUnit: 'lote desbloqueado | lotes desbloqueados',
      shareOnFacebook: 'Comparte en Facebook',
      subtitle: 'Con una membresía anual podrás conservar uno de nuestros parques.',
      title: '¡Eres asombroso!',
      placeholders: {
        couponCode: 'Escribe tu código acá',
        plots: 'Tus lotes PIC',
        selectProject: 'Elige un Parque',
      },
      errors: {
        default: 'Ha habido un problema, por favor intenta de nuevo.',
        plotNotFound: 'No pudimos encontrar un espacio, por favor intenta de nuevo',
      },
    },
    paymentSelector: {
      balance: 'Tu balance es $%{amount} %{currency}',
      coupon: 'Cupón',
      placeholders: {
        couponCode: 'Escribe tu código acá',
      },
      errors: {
        belongsOtherProjects: 'Este cupón pertenece al parque %{projects}. | Este cupón pertenece a los parques %{projects}.',
      },
    },
    picConfirm: {
      title: 'Comprar %{count} PIC | Comprar %{count} PICS',
    },
    photoUploader: {
      missing: 'Sube tu mejor foto.',
    },
    purchaseSidebar: {
      balance: 'Tu balance es $%{amount} %{currency}',
      benefits: 'Estás donando %{amount} por un apoyo anual a %{project}.',
      buyBtn: 'Comprar %{amount} pic! | Comprar %{amount} pics!',
      congratsMessage: 'Eres oficialmente un conservador de PIC en %{project}.{breakline}Muchas gracias por tu apoyo!',
      congratsTitle: '%{name}, eres asombroso!',
      continuePreserving: 'Continuar Preservando',
      coupon: 'Cupón',
      nextStepTitle: '¿Ahora qué sigue?',
      personalInfo: 'Info. Personal',
      shareWithWorld: 'Compartirlo con el mundo',
      shoppingSubtitle: 'Compra %{count} PIC en %{project} | Compra %{count} PICS en %{project}',
      terms: 'términos y condiciones',
      title: 'Compra un PIC. Apoya tu planeta',
      disclaimers: {
        acceptTerms: '%{icon} Yo acepto los %{link} de PIC.',
        age: 'Tengo a lo menos 16 años.',
      },
      errors: {
        belongsOtherProjects: 'Este cupón pertenece al parque %{projects}. | Este cupón pertenece a los parques %{projects}.',
        email: 'Por favor ingrese un correo válido.',
        name: 'Por favor ingrese un nombre.',
        invalidCouponCurrency: 'Este cupón es solo válido para proyectos con valor en %{currency}.',
      },
    },
    sidebar: {
      picparks: 'Proyectos PICparks',
      haveJoined: 'se unieron.',
      humidity: 'Humedad',
      morePeople: '%{count} persona más | %{count} personas más',
      picsLeft: '%{count} PIC faltante | %{count} PICS faltantes',
      preservedPercentage: '%{percentage}% PRESERVADO',
      zoomProjectBtn: 'Ir al proyecto!',
      createAlarmButton: 'Crear Alarma',
      destroyAlarmButton: 'Quitar Alarma',
    },
  },
};
